export default "__VITE_ASSET__CNT7JUcA__"